import RelatorioListarTurmaPage from "@/Pages/Relatorios/ListarTurmaPage.vue";
import lancarRelatorioBNCCPage from "@/Pages/Relatorios/lancarRelatorioBNCCPage.vue";
import lancarRelatorioDescritivoPage from "@/Pages/Relatorios/lancarRelatorioDescritivoPage.vue";
import relatorioPage from "@/Pages/Relatorios/index.vue";
import { can } from "@/plugins/can";

export default [
  {
    path: "/relatorios/:franquiaId",
    name: "relatorios",
    component: relatorioPage,
    beforeEnter(to, from, next) {
      if (!can(["relatorios.*"])) {
        return next({ name: "NaoAutorizado" });
      }
      return next();
    },
  },
  {
    path: "/relatorios/visualizar/:gestaoDeAulasId/:turmaId",
    name: "relatorios.visualizar",
    component: RelatorioListarTurmaPage,
  },
  {
    path: "/relatorios/lancarRelatorioBNCC/:matricula_id",
    name: "relatorios.lancarRelatorioBNCC",
    component: lancarRelatorioBNCCPage,
  },
  {
    path: "/relatorios/lancarRelatorioDescritivo/:matricula_id",
    name: "relatorios.lancarRelatorioDescritivo",
    component: lancarRelatorioDescritivoPage,
  },
];
